import { styled, alpha } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

import isColorDark from '../../../../../../../utils/isColorDark';

export const CopyBudgetModalStyled = styled(Paper)(({ theme }) => ({
  width: 500,
  maxHeight: 500,
  padding: 16,
  borderRadius: '12px',
  '& ul': {
    listStyle: 'none',
    fontFamily: theme.typography.body2.fontFamily,
    '& li': {
      margin: '10px 0',
      '& input': {
        visibility: 'hidden',
        height: 0,
        width: 0,
      },
      '& label': {
        cursor: 'pointer',
        display: 'inline-block',
        width: '100%',
        padding: '10px 0',
      },
      '& input:checked + label': {
        backgroundColor: alpha(theme.palette.primary.main, 0.7),
      },
    },
  },
}));

export const ItemsContainer = styled(Box)(({ theme }) => ({
  overflowY: 'scroll',
  maxHeight: 350,
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.primary.main,
    borderRadius: '8px',
    '&:hover': {
      background: theme.palette.secondary.main,
    },
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.primary.main} #f1f1f1`,
}));

export const ButtonsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '20px',
});

export const BtnModalStyled = styled(Button)(({ theme }) => ({
  height: 40,
  width: 220,
  display: 'flex',
  textTransform: 'none',
  color: '#000',
  backgroundColor: '#FFF',
  borderColor: theme.palette.primary.main,
  fontSize: '1rem',
  fontWeight: 600,
  '& svg': {
    marginRight: 8,
    fontSize: 22,
  },
}));

export const BtnItemsStyled = styled(Button)(({ theme }) => ({
  height: 40,
  width: 220,
  display: 'flex',
  color: isColorDark(theme.palette.primary.main)
    ? theme.palette.global.white
    : theme.palette.global.black,
  backgroundColor: theme.palette.primary.main,
  fontFamily: theme.typography.button,
  textTransform: 'none',
  fontSize: '1rem',
  fontWeight: 600,
  '& svg': {
    marginRight: 8,
    fontSize: 22,
  },
}));

export const LoadingStyled = styled(Box)({
  height: 350,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
